import { StatementListResponse, tigerxRest } from './tegerx.rest'
import { ETigerXAccount } from './tigerx.config'
import { tigerBackRest } from '../tigerBack/tigerBack.rest'
import { addBalancesToTransfers, groupTransfersByExchange, tigerXHistoryToHistoryItem } from './tigerx.mappers'
import { differenceInDays } from 'date-fns'
export interface ApiError {
  source: string
  status: number
  message: string
}

export const TigerXApi = {
  getTransferData: async () => {
    try {
      // Запускаем все запросы параллельно
      const [accountDataRes, assetsRes, balanceRes] = await Promise.all([
        tigerxRest.getAccountData().catch(err => {
          throw { source: 'accountData', status: err.response?.status || 500, message: err.message }
        }),
        tigerBackRest.getCoins().catch(err => {
          throw { source: 'assets', status: err.response?.status || 500, message: err.message }
        }),
        tigerBackRest.getCoinsBalance().catch(err => {
          throw { source: 'balance', status: err.response?.status || 500, message: err.message }
        }),
      ])

      const balances = accountDataRes.data.data.reduce((acc: Record<string, any>, item: any) => {
        acc[item.exchangeType] = {
          equity: item.equity,
        }
        return acc
      }, {})

      const groupedTransfers = groupTransfersByExchange(assetsRes.data)
      const balanceData = addBalancesToTransfers(groupedTransfers, balanceRes.data)

      const options = [
        {
          value: ETigerXAccount.TIGER_X_BINANCE,
          amount: balances['BINANCE'].equity,
          name: 'X Binance',
          coins: balanceData['BINANCE'],
        },
        {
          value: ETigerXAccount.TIGER_X_OKX,
          amount: balances['OKX'].equity,
          name: 'X OKX',
          coins: balanceData['OKX'],
        },
      ]

      const accountConfig = {
        TIGER_X_BINANCE: {
          name: 'X Binance',
          coins: balanceData['BINANCE'],
          account: 'BINANCE',
          type: 'SPOT',
        },
        TIGER_X_OKX: {
          name: 'X OKX',
          coins: balanceData['OKX'],
          account: 'OKX',
          type: 'SPOT',
        },
      }

      const transfer_data = {
        options: options,
        accountConfig: accountConfig,
        accountFrom: ETigerXAccount.TIGER_X_BINANCE,
        accountTo: ETigerXAccount.TIGER_X_OKX,
        maxDecimal: 6,
      }

      return transfer_data
    } catch (error: unknown) {
      const apiError = error as ApiError
      console.error('Error transfer data:', apiError)

      return {
        error: {
          source: apiError.source,
          status: apiError.status,
          message: apiError.message,
        },
      }
    }
  },
  getHistoryTradeData: async (filters: any) => {
    try {
      const now = new Date()
      const startTime = filters?.begin ? new Date(filters.begin) : null
      // const endTime = filters?.end ? new Date(filters.end) : now

      let isMoreThan7Days = false

      if (startTime) {
        const diffMs = now.getTime() - startTime.getTime()
        isMoreThan7Days = diffMs >= 7 * 24 * 60 * 60 * 1000
      }

      const params = { ...filters }

      if (!isMoreThan7Days) {
        delete params.pageSize
      }

      const [statmentDataRes] = await Promise.all([
        tigerxRest.getExecutions(params).catch(err => {
          throw { source: 'statmentData', status: err.response?.status || 500, message: err.message }
        }),
      ])

      const serverData = statmentDataRes.data.data

      let historyFormatted: ReturnType<typeof tigerXHistoryToHistoryItem>[] = []
      let page: number = 1
      let reachedEnd: boolean = true

      if (isMoreThan7Days) {
        const historyData = serverData as StatementListResponse
        historyFormatted = historyData.list.map(tigerXHistoryToHistoryItem)
        page = historyData.page
        reachedEnd = historyData.page * historyData.pageSize >= historyData.totalSize
      } else {
        if (Array.isArray(serverData)) {
          historyFormatted = serverData.map(tigerXHistoryToHistoryItem)
        } else {
          console.error('Unexpected serverData format:', serverData)
          historyFormatted = [] // fallback на пустой массив
        }
        page = 1
        reachedEnd = true
      }

      return {
        historyFormatted,
        page,
        reachedEnd,
      }
    } catch (error: unknown) {
      const apiError = error as ApiError
      console.error('Error transfer data:', apiError)

      return {
        error: {
          source: apiError.source,
          status: apiError.status,
          message: apiError.message,
        },
      }
    }
  },
}
